import createReactComponent from '../createReactComponent';
var BatteryLow = createReactComponent('BatteryLow', [['rect', {
  x: '2',
  y: '7',
  width: '16',
  height: '10',
  rx: '2',
  ry: '2',
  key: '5j9scf'
}], ['line', {
  x1: '22',
  x2: '22',
  y1: '11',
  y2: '13',
  key: '4dh1rd'
}], ['line', {
  x1: '6',
  x2: '6',
  y1: '10',
  y2: '14',
  key: 'ubtcxb'
}]]);
export default BatteryLow;